import React from 'react';

const MATURITY_LEVELS = [
  {
    key: 'TRADITIONAL',
    label: 'Traditional',
    short: 'TRAD',
    description: 'Manual processes, perimeter-based security, limited automation',
    color: 'var(--zt-traditional)'
  },
  {
    key: 'INITIAL',
    label: 'Initial',
    short: 'INIT',
    description: 'Some automation and policy enforcement, beginning identity-centric controls',
    color: 'var(--zt-initial)'
  },
  {
    key: 'ADVANCED',
    label: 'Advanced',
    short: 'ADV',
    description: 'Integrated controls across pillars, automated policy enforcement',
    color: 'var(--zt-advanced)'
  },
  {
    key: 'OPTIMAL',
    label: 'Optimal',
    short: 'OPT',
    description: 'Full Zero Trust implementation, AI-driven policy, continuous verification',
    color: 'var(--zt-optimal)'
  }
];

const MaturitySelector = ({ value, onChange, capabilityName }) => {
  return (
    <div className="maturity-selector">
      {capabilityName && (
        <div className="maturity-selector-cap">{capabilityName}</div>
      )}
      <div className="maturity-selector-options">
        {MATURITY_LEVELS.map(level => {
          const isSelected = value === level.key;
          return (
            <button
              key={level.key}
              className={`maturity-option ${isSelected ? 'maturity-option--selected' : ''}`}
              style={{
                borderColor: isSelected ? level.color : undefined,
                backgroundColor: isSelected ? `${level.color}18` : undefined
              }}
              onClick={() => onChange(level.key)}
              aria-pressed={isSelected}
            >
              <div
                className="maturity-option-dot"
                style={{ backgroundColor: level.color }}
              />
              <div className="maturity-option-content">
                <span
                  className="maturity-option-label"
                  style={{ color: isSelected ? level.color : undefined }}
                >
                  {level.label}
                </span>
                <span className="maturity-option-desc">{level.description}</span>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default MaturitySelector;
